import { InvoiceItems } from './invoiceItems';
import { InvoiceSetup } from './invoiceSetup';
import { Model } from './model';

export class InvoiceSetupItemArray extends Model {

  invoiceSetup!: InvoiceSetup;

  invoiceItems!: InvoiceItems[];
}
